import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-285daf84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-wrap" }
const _hoisted_2 = { class: "title xag-flex-lr" }
const _hoisted_3 = {
  key: 0,
  class: "title-description"
}
const _hoisted_4 = {
  key: 0,
  class: "wait-text"
}

import { withDefaults } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'block-wrap',
  props: {
    title: { default: '' },
    waitText: { default: '' },
    titleDescription: { default: '' }
  },
  setup(__props: any) {

const props = __props as { title: string, waitText: string, titleDescription: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, _toDisplayString(props.title), 1),
        (props.titleDescription)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.titleDescription), 1))
          : _createCommentVNode("", true)
      ]),
      _renderSlot(_ctx.$slots, "right")
    ]),
    _renderSlot(_ctx.$slots, "default"),
    (props.waitText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.waitText), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})